import { transparentize } from 'polished'
import styled, { css } from 'styled-components'

const Main = styled.main`
  ${({ theme }) => css`
    padding: 0;
    background-color: ${theme.palette.grey[50]};

    &:before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: ${theme.palette.grey[50]};
    }

    ${theme.media('sm')} {
      padding: 0 ${theme.spacing(7)};
    }

    ${theme.media('md')} {
      padding: 0 ${theme.spacing(10)};
    }
  `}
`

const QuizMain = styled.main`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    padding-bottom: 10rem;
    background-color: ${theme.palette.grey[50]};

    &:before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: ${theme.palette.grey[50]};
    }
  `}
`

const Form = styled.form`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: ${theme.spacing(5)};
    width: 100%;
    max-width: 56rem;
    padding: ${theme.spacing(5)} ${theme.spacing(4)};

    &.biggest {
      max-width: 100rem;
    }

    &.big {
      max-width: 80rem;
    }

    ${theme.media('sm')} {
      padding: 0 ${theme.spacing(4)};
    }
  `}
`

const FormGroup = styled.div`
  ${({ theme }) => css`
    display: grid;
    column-gap: ${theme.spacing(2)};
    row-gap: ${theme.spacing(2)};
    grid-template-columns: 1fr;

    ${theme.media('sm')} {
      grid-template-columns: 1fr 1fr 1fr;
    }
  `}
`

const FieldGroup = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `}
`

const Field = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};

    h4 {
      margin: 0;
    }
  `}
`

const Dialog = styled.div`
  ${({ theme }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: ${theme.spacing(2)};
    background-color: white;
  `}
`

const ActionBar = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    width: 100%;
    background: #fff;
    box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);

    ${theme.maxMedia('sm')} {
      position: fixed;
      z-index: 999999;
      bottom: 0;
      left: 0;
      padding: ${theme.spacing(2)};

      * {
        width: 100%;
      }
    }

    ${theme.media('sm')} {
      background-color: transparent;
      box-shadow: none;
      margin-top: auto;
    }
  `}
`

const GroupedFields = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spacing(3)};
    flex-direction: column;

    ${theme.media('xs')} {
      flex-direction: row;

      > * {
        flex-grow: 1;
        max-width: 50%;
      }
    }
  `}
`

const RadioGroup = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacing(1)};
  `}
`

const Label = styled.div`
  p {
    margin: 0;
  }
`

const TermsList = styled.div`
  ${({ theme }) => css`
    li {
      margin-bottom: ${theme.spacing(1)};

      p {
        margin: 0;
      }
    }
  `}
`

const AddressCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: baseline;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2)};
    background-color: ${theme.palette.grey[100]};

    > h5 {
      margin: 0;
    }

    > address {
      font-style: normal;
    }
  `}
`

const TextButton = styled.button.attrs({ type: 'button' })`
  ${({ theme }) => css`
    appearance: none;
    background: none;
    border: none;
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    padding: 0;
    margin: 0;
    text-decoration: underline;
    text-underline-position: under;
    text-decoration-color: ${transparentize(0.5, '#000')};

    &:hover {
      text-decoration-color: #000;
    }
  `}
`

const HintButton = styled.button.attrs({ type: 'button' })`
  ${({ theme }) => css`
    appearance: none;
    background: rgba(44, 41, 113, 0.1);
    color: rgba(44, 41, 113, 1);
    border: none;
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacing(0.5)};
    padding: 0.6rem 0.8rem 0.6rem 0.6rem;
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;

    &:hover {
      background: rgba(44, 41, 113, 0.2);
      text-decoration-color: #000;
    }

    &:active {
      background: rgba(44, 41, 113, 0.3);
    }
  `}
`

export default {
  Main,
  QuizMain,
  Form,
  FormGroup,
  FieldGroup,
  Field,
  Dialog,
  ActionBar,
  RadioGroup,
  TermsList,
  AddressCard,
  TextButton,
  HintButton,
  GroupedFields,
  Label,
}
